import { useTableStore } from "state/TableStore";
import { ColumnStateActions } from "customEnums/ColumnState";
import { TableNames } from "customEnums/TableNames";

const STATUS_FILTER_COLUMN = "status";
const TRANSACTION_SUMMARY_PAGE = "transaction-summary";
const MAX_RETRIES = 20;
const RETRY_DELAY_MS = 150;

export type DashboardSortOrder = 'NEWEST' | 'OLDEST';

const tryApplyFilter = (queueLabel: string): boolean => {
    const filters = useTableStore.getState()
        .columnState.page[TRANSACTION_SUMMARY_PAGE][TableNames.TRANSACTION_SUMMARY]
        ?.filters;

    const statusFilter = filters?.find((f: any) => f.filterColumn === STATUS_FILTER_COLUMN);
    if (!statusFilter) return false;

    const matchingKey = Object.keys(statusFilter.filterValues).find(
        (key) => statusFilter.filterValues[key].label === queueLabel
    );
    if (!matchingKey) return false;

    const columnStateDispatch = useTableStore.getState().columnStateDispatch;

    columnStateDispatch({
        type: ColumnStateActions.HIDE_ALL_FILTERS,
        page: TRANSACTION_SUMMARY_PAGE,
        tableName: TableNames.TRANSACTION_SUMMARY,
        column: STATUS_FILTER_COLUMN,
    });

    columnStateDispatch({
        type: ColumnStateActions.TOGGLE_FILTER,
        page: TRANSACTION_SUMMARY_PAGE,
        tableName: TableNames.TRANSACTION_SUMMARY,
        column: STATUS_FILTER_COLUMN,
        filter: matchingKey,
    });

    return true;
};

export const applyQueueStatusFilter = (
    queueLabel: string,
    sortOrder: DashboardSortOrder = 'NEWEST'
) => {
    const currentPagination = useTableStore.getState().pagination;
    useTableStore.getState().setPagination({
        ...currentPagination,
        [TableNames.TRANSACTION_SUMMARY]: {
            ...currentPagination[TableNames.TRANSACTION_SUMMARY],
            page: 1,
            orderBy: 'transactionDate',
            order: sortOrder === 'OLDEST' ? 'asc' : 'desc',
        },
    });

    let attempts = 0;
    const retryLoop = () => {
        const applied = tryApplyFilter(queueLabel);
        attempts += 1;

        if (!applied && attempts < MAX_RETRIES) {
            setTimeout(retryLoop, RETRY_DELAY_MS);
            return;
        }

        if (applied) {
            useTableStore.getState().setRunFilters(true);
        } else {
            console.log(`Dashboard drill-down: failed to apply filter for "${queueLabel}" after ${MAX_RETRIES} attempts`);
        }
    };

    retryLoop();
};